<template>
  <div class="complete-dialog-area">
    <el-dialog
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="complete-dialog"
    >
      <div class="complete-confirmation-dialog">
        <div class="dialog-header">
          <div class="header-text">{{ $t('complete_confirmation') }}</div>
        </div>
        <div class="dialog-body">
          <p class="confirmation-text">{{ $t('system_shutdown_message1') }}</p>
          <p class="confirmation-text">{{ $t('system_shutdown_message2') }}</p>
        </div>
        <div class="dialog-buttons">
          <button class="dialog-btn yes-btn" @click="handleConfirm">{{ $t('yes') }}</button>
          <button class="dialog-btn no-btn" @click="handleCancel">{{ $t('no') }}</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'CompleteConfirmationDialog',
  emits: ['update:modelValue', 'confirm', 'cancel'],
})
export default class CompleteConfirmationDialog extends Vue {
  @Prop({ type: Boolean, default: false }) modelValue!: boolean

  handleConfirm() {
    this.$emit('confirm')
  }

  handleCancel() {
    this.$emit('cancel')
    this.$emit('update:modelValue', false)
  }
}
</script>

<style lang="scss" scoped>
.complete-dialog-area {
  :deep(.el-dialog) {
    padding: 0;
    max-width: 1000px !important;
    width: 1000px !important;
  }

  :deep(.el-dialog__header) {
    display: none;
  }

  :deep(.el-dialog__body) {
    padding: 0;
  }

  .complete-confirmation-dialog {
    border: 5px solid #000;
    font-family: sans-serif;
    background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
  }

  .dialog-header {
    background: linear-gradient(180deg, #ff0000 0%, #cc0000 100%);
    border: 5px solid white;
    padding: 20px;
  }

  .header-text {
    background: linear-gradient(135deg, #ffff00 0%, #ffff99 100%);
    border: 3px solid #888;
    color: #ff0000;
    font-size: 60px;
    font-weight: bold;
    text-align: center;
    padding: 20px;
  }

  .dialog-body {
    text-align: center;
  }

  .confirmation-text {
    font-size: 48px;
    font-weight: bold;
    color: #000;
    margin: 10px 0;
    line-height: 1.5;
  }

  .dialog-buttons {
    display: flex;
    justify-content: center;
    gap: 60px;
    padding: 20px;
    background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
  }

  .dialog-btn {
    min-width: 250px;
    padding: 20px 40px;
    font-size: 36px;
    font-weight: bold;
    cursor: pointer;
    font-family: sans-serif;
    border-top: 2px solid white;
    border-left: 2px solid white;
    border-right: 2px solid black;
    border-bottom: 2px solid black;
    background: #d7d3cd;
    color: #ff0000;
  }
}
</style>
